// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Send = function Send(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.23 9.063 2.57 3.746l12.406 5.317zm0 1.875h9.746L2.57 16.254l2.656-5.316zM1.742 1.352a1.25 1.25 0 0 0-1.403.289c-.36.379-.441.95-.207 1.418L3.601 10 .132 16.942A1.25 1.25 0 0 0 .34 18.36c.36.382.918.496 1.403.293l17.5-7.5c.46-.196.758-.649.758-1.149s-.297-.953-.758-1.148l-17.5-7.5z"
  }));
};
